module.exports = __webpack_public_path__ + "media/en_gb_s3_Oliver.b3b6fe6b.oga";